import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

// Reuses the same component as the Google Step 2; the screen reads
// `location.pathname` to decide which platform context (connection lookup,
// connector code, back/forward targets) applies.
const ProductOverviewPage = lazy(
  () => import('~/features/onboarding/pages/product-overview-screen'),
);

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/meta/product-overview',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ProductOverviewPage />
    </Suspense>
  ),
});
